const color = "#292A33";

export const fallbackValues = {
  color
};
